<template>
  <div class="outer" @click="closePopup()">
    <div class="popup-wrapper" :style="{ width: width, height: height, 'max-height': `${maxHeight}`, 'max-width': `${maxWidth}`}" @click.stop>
      <div class="close" @click="closePopup()">
        <img src="@/assets/icons/close.svg" alt="close">
      </div>
      <div class="content">
        <slot></slot>
      </div>
      <div v-if="popUpButton" class="popup-button" @click="closePopup()">
        <slot name="button"></slot>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    width: {
      type: String,
      default: '600px'
    },
    height: {
      type: String,
      default: '364px'
    },
    maxHeight: {
      type: String,
      default: '80vh'
    },
    maxWidth: {
      type: String,
      default: '600px'
    },
    popUpButton: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {}
  },
  methods: {
    closePopup: function () {
      this.$emit('close', {
        close: false
      })
    }
  },
  mounted () {
    document.querySelector('body').style.overflow = 'hidden'
  },
  destroyed () {
    document.querySelector('body').style.overflow = null
  }
}
</script>

<style scoped lang="less">
.outer {
  position: fixed;
  z-index: 9000;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 25, 115, 0.9);
}

.popup-wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  margin: 80px 0;
  padding: 40px 0 0 0;
  box-sizing: border-box;
  background: var(--white);
  border-radius: var(--default-br);

  .popup-button {
    display: flex;
    margin: 20px 40px;
  }

  .close {
    display: flex;
    position: absolute;
    top: 9px;
    right: 9px;
    cursor: pointer;
  }

  .content {
    margin: 0 8px;
    padding: 0 32px 40px 32px;
    overflow-y: auto;
  }
}
</style>
